import React from "react";
import PropTypes from "prop-types";

import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

import { Mandators } from "../../mandators/Mandators.Component";
import ConfirmButton from "admin/common/components/ConfirmButton";
import InvestorLevel from "./InvestorLevel";
import InvestorTag from "./InvestorTag";
import { userDepotConnector } from "../../../../services/users/depot/connector";
import { compose } from "redux";
import { UsersOverviewConnector } from "../../../../services/users/connectors/Users.Overview.Connector";
import { getMainEmail } from "../../../../utilities/contact.info.helpers";
import moment from "moment";

export const IdentyDisplay = (props) => {
  let { currentUser } = props;
  let identity = "";
  let mandators = "";
  if (!currentUser) {
    return <div />;
  } else if (currentUser.LegalEntityType === "NaturalPerson") {
    identity = <NaturalPersonRender {...props} />;
  } else {
    identity = <OrganizationRender {...props} />;
    mandators = (
      <div className="col-md-12">
        <Divider />
        <Mandators {...props} />
      </div>
    );
  }

  return (
    <div className="row">
      <div className="col-md-6">{identity}</div>
      <div className="col-md-6">
        <Contacts {...props} />
      </div>
      {mandators}
    </div>
  );
};

export const NaturalPersonRender = (props) => {
  let mainInfoStyle = { padding: "8px 4px 4px 16px" };
  let { currentUser } = props;

  return (
    <React.Fragment>
      <List>
        <ListItem disabled={true} style={mainInfoStyle}>
          <ListItemText
            primary={currentUser.NaturalIdentityData.IdentityName.FullName}
            secondary="Full name"
          />
        </ListItem>
        {currentUser.NaturalIdentityData.IdentityName.GivenName ? (
          <ListItem disabled={true} style={mainInfoStyle}>
            <ListItemText
              primary={currentUser.NaturalIdentityData.IdentityName.GivenName}
              secondary="First name"
            />
          </ListItem>
        ) : undefined}
        {currentUser.NaturalIdentityData.IdentityName.Surname ? (
          <ListItem disabled={true} style={mainInfoStyle}>
            <ListItemText
              primary={currentUser.NaturalIdentityData.IdentityName.Surname}
              secondary="Last name"
            />
          </ListItem>
        ) : undefined}
        <SsnRendererConditional currentUser={currentUser} />
        {currentUser.NaturalIdentityData.Nationality ? (
          <ListItem disabled={true} style={mainInfoStyle}>
            <ListItemText
              primary={currentUser.NaturalIdentityData.Nationality}
              secondary="Nationality"
            />
          </ListItem>
        ) : undefined}
        <PhoneNumbers currentUser={currentUser} />
        <Emails currentUser={currentUser} />
        <UserIds currentUser={currentUser} />
        {currentUser.Domain === "Savelend" && (
          <InvestorLevel {...{ currentUser }} />
        )}
        {currentUser.Domain === "Savelend" &&
          currentUser.SegmentationTag !== undefined && (
            <InvestorTag currentUser={currentUser} />
          )}
        <GdprRemoveRender currentUser={currentUser} />
      </List>
    </React.Fragment>
  );
};

export const OrganizationRender = (props) => {
  let mainInfoStyle = { padding: "8px 4px 4px 16px" };
  let { currentUser } = props;
  let organisationName = "";
  let organisationNumber = "";
  if (currentUser.OrgIdentityData) {
    organisationName = currentUser.OrgIdentityData.IdentityName.FullName;
    organisationNumber = currentUser.OrgIdentityData.OrgNumber;
  }
  return (
    <List>
      <ListItem disabled={true} style={mainInfoStyle}>
        <ListItemText
          primary={organisationName}
          secondary="Organisation name"
        />
      </ListItem>
      <ListItem disabled={true} style={mainInfoStyle}>
        <ListItemText
          primary={organisationNumber}
          secondary="Organisation number"
        />
      </ListItem>
      <ListItem disabled={true} style={mainInfoStyle}>
        <ListItemText
          primary={currentUser.LegalEntityType}
          secondary="Legal entity type"
        />
      </ListItem>
      <PhoneNumbers currentUser={currentUser} />
      <Emails currentUser={currentUser} />
      <UserIds currentUser={currentUser} />
      {currentUser.Domain === "Savelend" && (
        <InvestorLevel currentUser={currentUser} />
      )}
      {currentUser.Domain === "Savelend" &&
        currentUser.SegmentationTag !== undefined && (
          <InvestorTag currentUser={currentUser} />
        )}
    </List>
  );
};

export const Contacts = (props) => {
  let mainInfoStyle = { padding: "8px 4px 4px 16px" };
  let { currentUser } = props;
  return (
    <List>
      {currentUser.AddressData.Addresses.length > 0 && (
        <React.Fragment>
          <ListItem disabled={true} style={mainInfoStyle}>
            <ListItemText
              primary={currentUser.AddressData.Addresses[0].Country}
              secondary="Country"
            />
          </ListItem>

          <ListItem disabled={true} style={mainInfoStyle}>
            <ListItemText
              primary={currentUser.AddressData.Addresses[0].Street}
              secondary="Address"
            />
          </ListItem>

          <ListItem disabled={true} style={mainInfoStyle}>
            <ListItemText
              primary={currentUser.AddressData.Addresses[0].PostalCode}
              secondary="ZIP"
            />
          </ListItem>

          <ListItem disabled={true} style={mainInfoStyle}>
            <ListItemText
              primary={currentUser.AddressData.Addresses[0].City}
              secondary="City"
            />
          </ListItem>
        </React.Fragment>
      )}
    </List>
  );
};

const SsnRendererConditional = ({ currentUser }) => {
  let mainInfoStyle = { padding: "8px 4px 4px 16px" };
  return (
    <ListItem disabled={true} style={mainInfoStyle}>
      {currentUser && currentUser.SSN && (
        <ListItemText primary={currentUser.SSN} secondary="SSN" />
      )}
    </ListItem>
  );
};

const _GdprRemoveRender = ({
  gdprRemove,
  gdprRemoveBorrower,
  gdprDeactivate,
  depot,
  currentUser,
  system,
}) => {
  const mainInfoStyle = { padding: "8px 4px 4px 16px" };
  const disableBorrowerButton = system.gdprCloseBorrower.sent;
  const disableInvestorButton = system.gdprCloseInvestor.sent;

  const disableGDPRDeactivateButton =
    system.gdprDeactivateInvestor.sent ||
    currentUser.Domain === "Loanstep" ||
    !depot.data[currentUser.Id] ||
    depot.data[currentUser.Id].reduce(
      (memo, item) => item.Value.Amount + memo,
      0,
    ) > 1 ||
    currentUser.InvestorDeactivatedAt;

  return (
    <div>
      <h4>
        To remove users without any transactions please use &quot;GDPR
        remove&quot; button for other cases use &quot;GDPR Deactivate&quot;
        button
      </h4>
      {currentUser.Domain === "Savelend" && (
        <ConfirmButton
          disabled={disableInvestorButton}
          label={"GDPR remove"}
          action={() => {
            gdprRemove(currentUser.PersonId);
          }}
        />
      )}
      {currentUser.Domain === "Loanstep" && (
        <ConfirmButton
          disabled={disableBorrowerButton}
          label={"GDPR remove"}
          action={() => {
            gdprRemoveBorrower(currentUser.SSN);
          }}
        />
      )}
      &nbsp;
      {currentUser.Domain === "Savelend" && (
        <ConfirmButton
          disabled={disableGDPRDeactivateButton}
          label={"GDPR Deactivate"}
          action={() => {
            gdprDeactivate(currentUser.Id);
          }}
        />
      )}
      {currentUser.Domain === "Savelend" && (
        <ListItem disabled={true} style={mainInfoStyle}>
          <ListItemText
            primary={moment(currentUser.InvestorDeactivatedAt).format(
              "YYYY-MM-DD",
            )}
            secondary="Investor deactivated"
          />
        </ListItem>
      )}
    </div>
  );
};

const GdprRemoveRender = compose(
  UsersOverviewConnector,
  userDepotConnector,
)(_GdprRemoveRender);

const PhoneNumbers = ({ currentUser }) => {
  let mainInfoStyle = { padding: "8px 4px 4px 16px" };
  if (currentUser.PhoneNumbers.MobilePhones.length == 0) return <div />;

  let number = currentUser.PhoneNumbers.MobilePhones[0];
  return (
    <div>
      <ListItem disabled={true} style={mainInfoStyle}>
        <ListItemText primary={number.Number} secondary="Phone" />
      </ListItem>
    </div>
  );
};

const Emails = ({ currentUser }) => {
  let mainInfoStyle = { padding: "8px 4px 4px 16px" };
  if (currentUser.EmailData.Emails.length == 0) return <div />;
  const email = getMainEmail(currentUser.EmailData);
  return (
    <div>
      <ListItem disabled={true} style={mainInfoStyle}>
        <ListItemText primary={email.EmailAddress} secondary="Email" />
      </ListItem>
    </div>
  );
};

const UserIds = ({ currentUser }) => {
  let mainInfoStyle = { padding: "8px 4px 4px 16px" };

  let idLabel = "Id";
  if (currentUser.Domain === "Loanstep") idLabel = "Borrower Id";
  else if (currentUser.Domain === "Savelend") idLabel = "Investor Id";

  return (
    <div>
      <ListItem disabled={true} style={mainInfoStyle}>
        <ListItemText primary={currentUser.Id} secondary={idLabel} />
      </ListItem>
      {currentUser.Domain == "Savelend" &&
      currentUser.LegalEntityType == "NaturalPerson" ? (
        <ListItem disabled={true} style={mainInfoStyle}>
          <ListItemText primary={currentUser.PersonId} secondary="Person Id" />
        </ListItem>
      ) : undefined}
    </div>
  );
};

let propTypes = {
  currentUser: PropTypes.object,
  users: PropTypes.object,
  mandatorError: PropTypes.string,
};

NaturalPersonRender.propTypes = propTypes;
SsnRendererConditional.propTypes = propTypes;
IdentyDisplay.propTypes = propTypes;
OrganizationRender.propTypes = propTypes;
PhoneNumbers.propTypes = propTypes;
Emails.propTypes = propTypes;
Contacts.propTypes = propTypes;
